import layoutHeaderAside from '@/layout/header-aside'

// 由于懒加载页面太多的话会造成webpack热更新太慢，所以开发环境不使用懒加载，只有生产环境使用懒加载
const _import = require('@/libs/util.import.' + process.env.NODE_ENV)

const meta = { auth: true }

export default {
    path: '/shopSelfOperation',
    name: 'shopSelfOperation',
    meta,
    redirect: { name: 'shopSelfOperation' },
    component: layoutHeaderAside,
    children: (pre => [
        {
            path: 'shopList',
            name: `${pre}shopList`,
            component: _import('shopForSelfOperation/shopList'),
            meta: {
                ...meta,
                title: '门店管理'
            }
        },
		{
		    path: 'shopBannerList',
		    name: `${pre}shopBannerList`,
		    component: _import('shopForSelfOperation/shopBannerList'),
		    meta: {
		        ...meta,
		        title: '店铺轮播图'
		    }
		},
        {
            path: 'shopCashierList',
            name: `${pre}shopCashierList`,
            component: _import('shopForSelfOperation/shopCashierList'),
            meta: {
                ...meta,
                title: '收银员管理'
            }
        },
		{
		    path: 'memberAccountList',
		    name: `${pre}memberAccountList`,
		    component: _import('shopForSelfOperation/memberAccountList'),
		    meta: {
		        ...meta,
		        title: '店铺会员管理'
		    }
		}
    ])('shopSelfOperation-')
}
